import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import EBillProviderForm from "./EBillProviderComponents/EBillProviderForm";

import {
  useGetEBillProviderDetailQuery,
  useUpdateEBillProviderMutation,
} from "store/services/eBillProviderApi";

import { useAppMeta } from "hooks";

const EBillProviderEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "eBill Providers", path: "/app/crm/ebill-provider/list" },
    { title: "Edit Provider" },
  ];

  // RTK Query
  const {
    data: eBillProviderDetail,
    isLoading: loadingEBillProvider,
    error,
  } = useGetEBillProviderDetailQuery(id);

  const [updateEBillProvider, { isLoading: updatingEBillProvider }] =
    useUpdateEBillProviderMutation();

  // Update handler
  const handleUpdateEBillProvider = async (data) => {
    const payload = { _id: id, ...data };

    try {
      await updateEBillProvider(payload).unwrap();
      toast.success("eBill Provider successfully updated!");
      navigate(`/app/crm/ebill-provider/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update eBill Provider!"
      );
    }
  };

  useAppMeta("Edit eBill Provider");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingEBillProvider || updatingEBillProvider}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <EBillProviderForm
          isBusy={loadingEBillProvider || updatingEBillProvider}
          eBillProviderDetail={eBillProviderDetail}
          onSubmit={handleUpdateEBillProvider}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default EBillProviderEditScreen;